export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4857.fe6a9da1.jpg";